/**
 *
 * OutOfLimitTag
 *
 */

import React, { memo } from 'react';
import styled from 'styled-components';

import CircleIcon from 'assets/v2/CircleIcon';
import { COLORS } from 'theme';
import Tag from '..';

const StyledTag = styled(Tag)`
  &.MuiChip-root {
    color: ${COLORS.crayolaDark};
    background: ${COLORS.crayolaLight};
    border-color: ${COLORS.crayolaDark};
    border-radius: ${({ theme }) => theme.borderRadius.secondary};

    &&& .MuiChip-icon path {
      fill: ${COLORS.crayola};
    }
  }
`;

function OutOfLimitTag(props) {
  return <StyledTag label="Out of Limit" icon={<CircleIcon />} {...props} />;
}

export default memo(OutOfLimitTag);
